import ToolTip from './Tooltip'
export default ToolTip




// WEBPACK FOOTER //
// ./components/tooltip/index.js